import React from "react";
import { Add as AddIcon, Email } from "@mui/icons-material";

import {
  Button,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Tooltip,
  Typography,
} from "@mui/material";

import useDocumentTitle from "./useDocumentTitle";
import {
  setIsLetterTemplateMenu,
  setIsNowShowLetterMenu,
  setIsUploadModalOpen,
} from "app/store/patientProfile/documents/slice/patientProfileDocumentSlice";
import { USER_ROLES } from "static/constants";
import useCheckSaasAccountUser from "hooks/useCheckSaasAccountUser";

const DocumentsTitle = () => {
  const {
    anchorRef,
    isLetterTemplateMenu,
    isNoShowLetterMenu,

    letterTemplates,
    nowShowLetters,
    currentUser,
    noShowAnchorRef,

    dispatch,
    handleTemplateSelection,
    handleNoShowTemplateSelection,
  } = useDocumentTitle();
  const isSaasAccountUser = useCheckSaasAccountUser();

  return (
    <div style={{ marginLeft: "5px", marginTop: "5px" }}>
      <div style={{ fontSize: "21px", fontWeight: "500" }}>Documents</div>
      <div
        className="d-flex"
        style={{
          fontSize: "12px",
          fontWeight: "400",
          marginTop: "10px",
          marginBottom: "10px",
          gap: "10px",
        }}
      >
        <Button
          color="secondary"
          variant="contained"
          disableElevation
          onClick={() => dispatch(setIsUploadModalOpen(true))}
          startIcon={<AddIcon />}
        >
          Add Document
        </Button>

        {(currentUser?.role !== USER_ROLES.CLINIC_ADMIN ||
          !isSaasAccountUser) && (
          <Tooltip title="No Show Letters" placement="bottom">
            <Button
              color="secondary"
              variant="outlined"
              className="generate-letter-button"
              disableElevation
              ref={noShowAnchorRef}
              onClick={() =>
                dispatch(setIsNowShowLetterMenu(!isNoShowLetterMenu))
              }
            >
              <Email className="mr-2" />
              No Show Letters
            </Button>
          </Tooltip>
        )}

        {(currentUser?.role !== USER_ROLES.CLINIC_ADMIN ||
          !isSaasAccountUser) && (
          <Tooltip title="Letter Templates" placement="bottom">
            <Button
              color="secondary"
              variant="outlined"
              className="generate-letter-button"
              disableElevation
              ref={anchorRef}
              onClick={() =>
                dispatch(setIsLetterTemplateMenu(!isLetterTemplateMenu))
              }
            >
              <Email className="mr-2" /> Letter Templates
            </Button>
          </Tooltip>
        )}

        <Popper
          style={{ zIndex: 11 }}
          open={isLetterTemplateMenu}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
          placement="bottom-start"
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: "bottom-end",
              }}
            >
              <Paper>
                <ClickAwayListener
                  onClickAway={() => dispatch(setIsLetterTemplateMenu(false))}
                >
                  <div className="menu-list-container">
                    <Typography className="menu-title">
                      <span className="menu-title-text">
                        Select a letter type
                      </span>
                    </Typography>

                    <MenuList
                      autoFocusItem={isLetterTemplateMenu}
                      id="menu-list-grow"
                      className="menu-list"
                    >
                      {letterTemplates?.map((template, index) => (
                        <MenuItem
                          key={index}
                          className="menu-list-item"
                          onClick={() => {
                            handleTemplateSelection(template);
                          }}
                        >
                          <Typography textAlign="center">
                            {template.template_name}
                          </Typography>
                        </MenuItem>
                      ))}
                    </MenuList>
                  </div>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>

        <Popper
          style={{ zIndex: 11 }}
          open={isNoShowLetterMenu}
          anchorEl={noShowAnchorRef.current}
          role={undefined}
          transition
          disablePortal
          placement="bottom-start"
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: "bottom-end",
              }}
            >
              <Paper>
                <ClickAwayListener
                  onClickAway={() => dispatch(setIsNowShowLetterMenu(false))}
                >
                  <div className="menu-list-container">
                    <Typography className="menu-title">
                      <span className="menu-title-text">
                        Select a no show letter
                      </span>
                    </Typography>

                    <MenuList
                      autoFocusItem={isNoShowLetterMenu}
                      id="menu-list-grow"
                      className="menu-list"
                    >
                      {nowShowLetters?.map((template, index) => (
                        <MenuItem
                          key={index}
                          className="menu-list-item"
                          onClick={() => {
                            handleNoShowTemplateSelection(template);
                          }}
                        >
                          <Typography textAlign="center">
                            {template.template_name}
                          </Typography>
                        </MenuItem>
                      ))}
                    </MenuList>
                  </div>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </div>
  );
};

export default DocumentsTitle;
